import { ValidatorFn, Validators } from '@angular/forms';

export function PassportValidator(): ValidatorFn {
  return Validators.pattern('^[a-zA-Z0-9<\/*-]{6,14}$');
}